/* Sticky Menu */
/*
jQuery(document).ready(function($) {
  var $filter = $('.engoj_sticky');
  var $filterSpacer = $('<div />', {
    "class": "nguyenhuuphuc_ptit",
    "height": $filter.outerHeight()
  });
  if ($filter.size())
  {
    $(window).scroll(function ()
                     {
      if (!$filter.hasClass('engoc_fixed') && $(window).scrollTop() > $filter.offset().top)
      {
        $filter.before($filterSpacer);
        $filter.addClass("engoc_fixed");
      }
      else if ($filter.hasClass('engoc_fixed')  && $(window).scrollTop() < $filterSpacer.offset().top)
      {
        $filter.removeClass("engoc_fixed");
        $filterSpacer.remove();
      }
    });
  }

});
*/

/* Hover color change image product */
jQuery(document).ready(function($) {
  jQuery('.engoj_select_color a').each(function(){
    jQuery(this).on("mouseover",function(){
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img').attr({ src: engoImage }); 
      return false;
    });
  });
});